<template>
  <div class="gateway-item-component">
    <div class="no">{{no}}</div>
    <div class="gateway_id">
      {{ gateway_id }}
    </div>
    <div class="email">
      <div ref="emailEditor" :contenteditable="isEditable" @input="onInput">{{ email }}</div>
    </div>
    <div class="action_group">
      <button class="btn btn-edit" @click="onClickUpdate()">
        <template v-if="!isEditable"> &#x270E; </template>
        <template v-else> &#10003; </template>
      </button>
      <button :class="['btn btn-delete', isEditable ? 'btn-disable' : '']" @click="deleteGateway()">&#x1F5D1;</button>
    </div>
  </div>
</template>

<script>
import service from "@/net/index.js";
export default {
  name: "GatewayRowItem",
  props: {
    no: {
      type: Number,
      required: true
    },
    gateway: {
      type:Object,
      required: true
    }
  },
  data() {
    return {
      email: "",
      gateway_id: "",
      new_email_address: "",
      isEditable: false
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    onInput(e) {
      this.new_email_address = e.target.innerText;
    },
    init() {
      this.email = this.gateway.email;
      this.gateway_id = this.gateway.gatewayId;
      this.new_email_address = this.email;
    },
    onClickUpdate() {
      if (this.isEditable) {
        if (this.new_email_address.length < 1) {
          this.$store.state.notifications = {
            type: "error",
            title: "Validation Error",
            message: "Email Address should be given!",
            eventTime: new Date()
          };
          this.$refs['emailEditor'].focus();
          return;
        }
        if (!this.validateEmail(this.new_email_address)) {
          this.$store.state.notifications = {
            type: "error",
            title: "Validation Error",
            message: "Email Validation Error!",
            eventTime: new Date()
          }
          this.$refs['emailEditor'].focus();
          return;
        }
      }
      this.isEditable = !this.isEditable;
      if (!this.isEditable) {
        if (this.email !== this.new_email_address) {
          this.$store.state.isLoading = true;
          service.updateGateway(this.new_email_address, this.gateway_id).then(res=>{
            if (res.status === 200) {
              this.$store.state.notifications = {
                type: "success",
                title: "Success",
                message: "Email Address was updated successfully",
                eventTime: new Date()
              }
              this.$store.state.refreshEvent = new Date().getTime();
            }
          })
        }
      }
    },
    deleteGateway() {
      if (this.isEditable) {
        this.$refs['emailEditor'].focus();
        return;
      }
      this.$modal.show('dialog', {
        title: 'Warnning!',
        text: 'Are you sure you want to remove Gateway( id: ' + this.gateway_id + ' ) on ' + this.email + '?',
        buttons: [
          {
            title: 'Confirm',
            handler: () => {
              this.procceedDelete()
            }
          },
          {
            title: 'Cancel',
            handler: () => {
              this.$modal.hide('dialog');
            }
          }
        ]
      });
    },
    procceedDelete() {
      this.$modal.hide('dialog');
      this.$store.state.isLoading = true;
      service.deleteGateway(this.email, this.gateway_id).then(res=> {
        if (res.status === 200) {
          this.$store.state.notifications = {
            type: "success",
            title: "Success",
            message: "Gateway( id:" + this.gateway_id + " ) was removed on " + this.email + " successfully!",
            eventTime: new Date()
          }
          this.$store.state.refreshEvent = new Date().getTime();
        }
      })
    },
    validateEmail(email) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  },
  watch: {
    gateway: function() {
      this.init();
    }
  }
}
</script>
<style lang="scss">
  .gateway-item-component {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E5E5E5;
    padding: 5px 0px;
    .no {
      width: 100px;
      min-width: 100px;
    }
    .email {
      width: 100%;
      text-align: left;
      padding: 0px 10px;
      div {
        outline: none;
        padding: 5px;
        &[contenteditable=true] {
         background-color: #E5E5E5; 
        }
      }
    }
    .gateway_id {
      width: 200px;
      min-width: 200px;
      text-align: left;
      padding: 5px 10px;
    }
    .action_group {
      width: 130px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      min-width: 130px;
      button {
        margin-right: 10px;
        margin-bottom: 0px;
        padding: 0px;
        height: 35px;
        width: 35px;
        &.btn-edit {
          font-size: 18px;
        }
        &.btn-disable {
          opacity: 0.3;
          outline: none !important;
          pointer-events: none;
        }
      }
    }
  }
</style>